// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorContainer_errorContainer__dEq+x"};